var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6, _mask7, _rect7, _mask8, _rect8, _mask9, _rect9, _mask10, _rect10, _mask11, _rect11, _mask12, _rect12, _mask13, _rect13, _mask14, _rect14, _mask15, _rect15, _mask16, _rect16, _mask17, _rect17, _mask18, _rect18, _mask19, _rect19, _mask20, _rect20, _mask21, _rect21, _mask22, _rect22, _mask23, _rect23, _mask24, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect38, _rect39;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourlyLayoutImg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 326,
    viewBox: "0 0 470 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-1-inside-1_8006_9634)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.0098,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0098,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-2-inside-2_8006_9634)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.4375,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4375,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-3-inside-3_8006_9634)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4482,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4482,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-4-inside-4_8006_9634)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.459,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79.459,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-5-inside-5_8006_9634)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.8857,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92.8857,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-6-inside-6_8006_9634)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-7_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.897,
    y: 283.25,
    width: 11.0918,
    height: 18.75,
    rx: 2.77916
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106.897,
    y: 283.25,
    width: 11.0918,
    height: 18.75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-7-inside-7_8006_9634)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-8_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.908,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 120.908,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-8-inside-8_8006_9634)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-9_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-9-inside-9_8006_9634)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-10_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.01,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 195.01,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-10-inside-10_8006_9634)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-11_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.438,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 208.438,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-11-inside-11_8006_9634)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-12_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.448,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 222.448,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-12-inside-12_8006_9634)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-13_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.459,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 236.459,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-13-inside-13_8006_9634)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-14_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.886,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 249.886,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-14-inside-14_8006_9634)"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-15_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.897,
    y: 283.25,
    width: 11.0918,
    height: 18.75,
    rx: 2.77916
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 263.897,
    y: 283.25,
    width: 11.0918,
    height: 18.75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-15-inside-15_8006_9634)"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-16_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.908,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 277.908,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-16-inside-16_8006_9634)"
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-17_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-17-inside-17_8006_9634)"
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-18_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.01,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 354.01,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-18-inside-18_8006_9634)"
  })), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-19_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.438,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 367.438,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-19-inside-19_8006_9634)"
  })), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-20_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.448,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 381.448,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-20-inside-20_8006_9634)"
  })), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-21_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.459,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 395.459,
    y: 227,
    width: 11.0918,
    height: 75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-21-inside-21_8006_9634)"
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-22_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.886,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 408.886,
    y: 264.5,
    width: 11.0918,
    height: 37.5,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-22-inside-22_8006_9634)"
  })), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-23_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.897,
    y: 283.25,
    width: 11.0918,
    height: 18.75,
    rx: 2.77916
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 422.897,
    y: 283.25,
    width: 11.0918,
    height: 18.75,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-23-inside-23_8006_9634)"
  })), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-24_8006_9634",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.908,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 436.908,
    y: 245.75,
    width: 11.0918,
    height: 56.25,
    rx: 2.77916,
    stroke: "#0A71CE",
    strokeWidth: 11.0918,
    mask: "url(#path-24-inside-24_8006_9634)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 466,
    height: 322,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 45,
    width: 45,
    height: 39,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 45,
    width: 45,
    height: 39,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 45,
    width: 45,
    height: 39,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 45,
    width: 45,
    height: 39,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 45,
    width: 45,
    height: 39,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 45,
    width: 45,
    height: 39,
    rx: 2,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 96,
    width: 45,
    height: 65,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 96,
    width: 45,
    height: 65,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 96,
    width: 45,
    height: 65,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 96,
    width: 45,
    height: 65,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 96,
    width: 45,
    height: 65,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 96,
    width: 45,
    height: 65,
    rx: 2,
    fill: "#0A71CE",
    fillOpacity: 0.5,
    stroke: "#4C4C4C",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3594 58.625V70H30.0156V58.625H32.3594ZM39.1719 58.625L34.6641 64.2422L32.0625 67.0391L31.6406 64.8203L33.3984 62.4141L36.2969 58.625H39.1719ZM36.5078 70L33.1562 64.7422L34.8906 63.2891L39.2812 70H36.5078ZM44.7672 65.9453H41.8687V64.1172H44.7672C45.2151 64.1172 45.5797 64.0443 45.8609 63.8984C46.1422 63.7474 46.3479 63.5391 46.4781 63.2734C46.6083 63.0078 46.6734 62.7083 46.6734 62.375C46.6734 62.0365 46.6083 61.7214 46.4781 61.4297C46.3479 61.138 46.1422 60.9036 45.8609 60.7266C45.5797 60.5495 45.2151 60.4609 44.7672 60.4609H42.6812V70H40.3375V58.625H44.7672C45.6578 58.625 46.4208 58.7865 47.0562 59.1094C47.6969 59.4271 48.1865 59.8672 48.525 60.4297C48.8635 60.9922 49.0328 61.6354 49.0328 62.3594C49.0328 63.0938 48.8635 63.7292 48.525 64.2656C48.1865 64.8021 47.6969 65.2161 47.0562 65.5078C46.4208 65.7995 45.6578 65.9453 44.7672 65.9453ZM53.2922 58.625V70H50.9562V58.625H53.2922ZM65.0219 58.6016V70H62.7719V61.1953L60.0688 62.0547V60.2812L64.7797 58.6016H65.0219Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.359 58.625V70H187.016V58.625H189.359ZM196.172 58.625L191.664 64.2422L189.062 67.0391L188.641 64.8203L190.398 62.4141L193.297 58.625H196.172ZM193.508 70L190.156 64.7422L191.891 63.2891L196.281 70H193.508ZM201.767 65.9453H198.869V64.1172H201.767C202.215 64.1172 202.58 64.0443 202.861 63.8984C203.142 63.7474 203.348 63.5391 203.478 63.2734C203.608 63.0078 203.673 62.7083 203.673 62.375C203.673 62.0365 203.608 61.7214 203.478 61.4297C203.348 61.138 203.142 60.9036 202.861 60.7266C202.58 60.5495 202.215 60.4609 201.767 60.4609H199.681V70H197.337V58.625H201.767C202.658 58.625 203.421 58.7865 204.056 59.1094C204.697 59.4271 205.186 59.8672 205.525 60.4297C205.864 60.9922 206.033 61.6354 206.033 62.3594C206.033 63.0938 205.864 63.7292 205.525 64.2656C205.186 64.8021 204.697 65.2161 204.056 65.5078C203.421 65.7995 202.658 65.9453 201.767 65.9453ZM210.292 58.625V70H207.956V58.625H210.292ZM222.022 58.6016V70H219.772V61.1953L217.069 62.0547V60.2812L221.78 58.6016H222.022Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M348.359 58.625V70H346.016V58.625H348.359ZM355.172 58.625L350.664 64.2422L348.062 67.0391L347.641 64.8203L349.398 62.4141L352.297 58.625H355.172ZM352.508 70L349.156 64.7422L350.891 63.2891L355.281 70H352.508ZM360.767 65.9453H357.869V64.1172H360.767C361.215 64.1172 361.58 64.0443 361.861 63.8984C362.142 63.7474 362.348 63.5391 362.478 63.2734C362.608 63.0078 362.673 62.7083 362.673 62.375C362.673 62.0365 362.608 61.7214 362.478 61.4297C362.348 61.138 362.142 60.9036 361.861 60.7266C361.58 60.5495 361.215 60.4609 360.767 60.4609H358.681V70H356.337V58.625H360.767C361.658 58.625 362.421 58.7865 363.056 59.1094C363.697 59.4271 364.186 59.8672 364.525 60.4297C364.864 60.9922 365.033 61.6354 365.033 62.3594C365.033 63.0938 364.864 63.7292 364.525 64.2656C364.186 64.8021 363.697 65.2161 363.056 65.5078C362.421 65.7995 361.658 65.9453 360.767 65.9453ZM369.292 58.625V70H366.956V58.625H369.292ZM381.022 58.6016V70H378.772V61.1953L376.069 62.0547V60.2812L380.78 58.6016H381.022Z",
    fill: "#4C4C4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3281 26.1719V28H26.6016V26.1719H32.3281ZM27.3594 16.625V28H25.0156V16.625H27.3594ZM36.3141 16.625V28H33.9781V16.625H36.3141ZM47.9172 16.625V28H45.5734L41.0031 20.375V28H38.6594V16.625H41.0031L45.5813 24.2578V16.625H47.9172ZM57.7391 26.1719V28H51.6844V26.1719H57.7391ZM52.45 16.625V28H50.1063V16.625H52.45ZM56.95 21.2578V23.0391H51.6844V21.2578H56.95ZM57.7313 16.625V18.4609H51.6844V16.625H57.7313ZM68.6406 16.6016V28H66.3906V19.1953L63.6875 20.0547V18.2812L68.3984 16.6016H68.6406Z",
    fill: "#4C4C4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.328 26.1719V28H183.602V26.1719H189.328ZM184.359 16.625V28H182.016V16.625H184.359ZM193.314 16.625V28H190.978V16.625H193.314ZM204.917 16.625V28H202.573L198.003 20.375V28H195.659V16.625H198.003L202.581 24.2578V16.625H204.917ZM214.739 26.1719V28H208.684V26.1719H214.739ZM209.45 16.625V28H207.106V16.625H209.45ZM213.95 21.2578V23.0391H208.684V21.2578H213.95ZM214.731 16.625V18.4609H208.684V16.625H214.731ZM227.938 26.2422V28H220.156V26.5L223.836 22.5547C224.206 22.1432 224.497 21.7812 224.711 21.4688C224.924 21.151 225.078 20.8672 225.172 20.6172C225.271 20.362 225.32 20.1198 225.32 19.8906C225.32 19.5469 225.263 19.2526 225.148 19.0078C225.034 18.7578 224.865 18.5651 224.641 18.4297C224.422 18.2943 224.151 18.2266 223.828 18.2266C223.484 18.2266 223.188 18.3099 222.938 18.4766C222.693 18.6432 222.505 18.875 222.375 19.1719C222.25 19.4688 222.188 19.8047 222.188 20.1797H219.93C219.93 19.5026 220.091 18.8828 220.414 18.3203C220.737 17.7526 221.193 17.3021 221.781 16.9688C222.37 16.6302 223.068 16.4609 223.875 16.4609C224.672 16.4609 225.344 16.5911 225.891 16.8516C226.443 17.1068 226.859 17.4766 227.141 17.9609C227.427 18.4401 227.57 19.013 227.57 19.6797C227.57 20.0547 227.51 20.4219 227.391 20.7812C227.271 21.1354 227.099 21.4896 226.875 21.8438C226.656 22.1927 226.391 22.5469 226.078 22.9062C225.766 23.2656 225.419 23.638 225.039 24.0234L223.062 26.2422H227.938Z",
    fill: "#4C4C4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348.328 26.1719V28H342.602V26.1719H348.328ZM343.359 16.625V28H341.016V16.625H343.359ZM352.314 16.625V28H349.978V16.625H352.314ZM363.917 16.625V28H361.573L357.003 20.375V28H354.659V16.625H357.003L361.581 24.2578V16.625H363.917ZM373.739 26.1719V28H367.684V26.1719H373.739ZM368.45 16.625V28H366.106V16.625H368.45ZM372.95 21.2578V23.0391H367.684V21.2578H372.95ZM373.731 16.625V18.4609H367.684V16.625H373.731ZM386.938 26.2422V28H379.156V26.5L382.836 22.5547C383.206 22.1432 383.497 21.7812 383.711 21.4688C383.924 21.151 384.078 20.8672 384.172 20.6172C384.271 20.362 384.32 20.1198 384.32 19.8906C384.32 19.5469 384.263 19.2526 384.148 19.0078C384.034 18.7578 383.865 18.5651 383.641 18.4297C383.422 18.2943 383.151 18.2266 382.828 18.2266C382.484 18.2266 382.188 18.3099 381.938 18.4766C381.693 18.6432 381.505 18.875 381.375 19.1719C381.25 19.4688 381.188 19.8047 381.188 20.1797H378.93C378.93 19.5026 379.091 18.8828 379.414 18.3203C379.737 17.7526 380.193 17.3021 380.781 16.9688C381.37 16.6302 382.068 16.4609 382.875 16.4609C383.672 16.4609 384.344 16.5911 384.891 16.8516C385.443 17.1068 385.859 17.4766 386.141 17.9609C386.427 18.4401 386.57 19.013 386.57 19.6797C386.57 20.0547 386.51 20.4219 386.391 20.7812C386.271 21.1354 386.099 21.4896 385.875 21.8438C385.656 22.1927 385.391 22.5469 385.078 22.9062C384.766 23.2656 384.419 23.638 384.039 24.0234L382.062 26.2422H386.938Z",
    fill: "#4C4C4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3594 58.625V70H87.0156V58.625H89.3594ZM96.1719 58.625L91.6641 64.2422L89.0625 67.0391L88.6406 64.8203L90.3984 62.4141L93.2969 58.625H96.1719ZM93.5078 70L90.1562 64.7422L91.8906 63.2891L96.2812 70H93.5078ZM101.767 65.9453H98.8687V64.1172H101.767C102.215 64.1172 102.58 64.0443 102.861 63.8984C103.142 63.7474 103.348 63.5391 103.478 63.2734C103.608 63.0078 103.673 62.7083 103.673 62.375C103.673 62.0365 103.608 61.7214 103.478 61.4297C103.348 61.138 103.142 60.9036 102.861 60.7266C102.58 60.5495 102.215 60.4609 101.767 60.4609H99.6812V70H97.3375V58.625H101.767C102.658 58.625 103.421 58.7865 104.056 59.1094C104.697 59.4271 105.186 59.8672 105.525 60.4297C105.864 60.9922 106.033 61.6354 106.033 62.3594C106.033 63.0938 105.864 63.7292 105.525 64.2656C105.186 64.8021 104.697 65.2161 104.056 65.5078C103.421 65.7995 102.658 65.9453 101.767 65.9453ZM110.292 58.625V70H107.956V58.625H110.292ZM124.319 68.2422V70H116.538V68.5L120.217 64.5547C120.587 64.1432 120.879 63.7812 121.092 63.4688C121.306 63.151 121.459 62.8672 121.553 62.6172C121.652 62.362 121.702 62.1198 121.702 61.8906C121.702 61.5469 121.644 61.2526 121.53 61.0078C121.415 60.7578 121.246 60.5651 121.022 60.4297C120.803 60.2943 120.532 60.2266 120.209 60.2266C119.866 60.2266 119.569 60.3099 119.319 60.4766C119.074 60.6432 118.886 60.875 118.756 61.1719C118.631 61.4688 118.569 61.8047 118.569 62.1797H116.311C116.311 61.5026 116.472 60.8828 116.795 60.3203C117.118 59.7526 117.574 59.3021 118.163 58.9688C118.751 58.6302 119.449 58.4609 120.256 58.4609C121.053 58.4609 121.725 58.5911 122.272 58.8516C122.824 59.1068 123.241 59.4766 123.522 59.9609C123.808 60.4401 123.952 61.013 123.952 61.6797C123.952 62.0547 123.892 62.4219 123.772 62.7812C123.652 63.1354 123.48 63.4896 123.256 63.8438C123.038 64.1927 122.772 64.5469 122.459 64.9062C122.147 65.2656 121.801 65.638 121.42 66.0234L119.444 68.2422H124.319Z",
    fill: "#4C4C4C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M246.359 58.625V70H244.016V58.625H246.359ZM253.172 58.625L248.664 64.2422L246.062 67.0391L245.641 64.8203L247.398 62.4141L250.297 58.625H253.172ZM250.508 70L247.156 64.7422L248.891 63.2891L253.281 70H250.508ZM258.767 65.9453H255.869V64.1172H258.767C259.215 64.1172 259.58 64.0443 259.861 63.8984C260.142 63.7474 260.348 63.5391 260.478 63.2734C260.608 63.0078 260.673 62.7083 260.673 62.375C260.673 62.0365 260.608 61.7214 260.478 61.4297C260.348 61.138 260.142 60.9036 259.861 60.7266C259.58 60.5495 259.215 60.4609 258.767 60.4609H256.681V70H254.337V58.625H258.767C259.658 58.625 260.421 58.7865 261.056 59.1094C261.697 59.4271 262.186 59.8672 262.525 60.4297C262.864 60.9922 263.033 61.6354 263.033 62.3594C263.033 63.0938 262.864 63.7292 262.525 64.2656C262.186 64.8021 261.697 65.2161 261.056 65.5078C260.421 65.7995 259.658 65.9453 258.767 65.9453ZM267.292 58.625V70H264.956V58.625H267.292ZM281.319 68.2422V70H273.538V68.5L277.217 64.5547C277.587 64.1432 277.879 63.7812 278.092 63.4688C278.306 63.151 278.459 62.8672 278.553 62.6172C278.652 62.362 278.702 62.1198 278.702 61.8906C278.702 61.5469 278.644 61.2526 278.53 61.0078C278.415 60.7578 278.246 60.5651 278.022 60.4297C277.803 60.2943 277.532 60.2266 277.209 60.2266C276.866 60.2266 276.569 60.3099 276.319 60.4766C276.074 60.6432 275.886 60.875 275.756 61.1719C275.631 61.4688 275.569 61.8047 275.569 62.1797H273.311C273.311 61.5026 273.472 60.8828 273.795 60.3203C274.118 59.7526 274.574 59.3021 275.163 58.9688C275.751 58.6302 276.449 58.4609 277.256 58.4609C278.053 58.4609 278.725 58.5911 279.272 58.8516C279.824 59.1068 280.241 59.4766 280.522 59.9609C280.808 60.4401 280.952 61.013 280.952 61.6797C280.952 62.0547 280.892 62.4219 280.772 62.7812C280.652 63.1354 280.48 63.4896 280.256 63.8438C280.038 64.1927 279.772 64.5469 279.459 64.9062C279.147 65.2656 278.801 65.638 278.42 66.0234L276.444 68.2422H281.319Z",
    fill: "#4C4C4C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M405.359 58.625V70H403.016V58.625H405.359ZM412.172 58.625L407.664 64.2422L405.062 67.0391L404.641 64.8203L406.398 62.4141L409.297 58.625H412.172ZM409.508 70L406.156 64.7422L407.891 63.2891L412.281 70H409.508ZM417.767 65.9453H414.869V64.1172H417.767C418.215 64.1172 418.58 64.0443 418.861 63.8984C419.142 63.7474 419.348 63.5391 419.478 63.2734C419.608 63.0078 419.673 62.7083 419.673 62.375C419.673 62.0365 419.608 61.7214 419.478 61.4297C419.348 61.138 419.142 60.9036 418.861 60.7266C418.58 60.5495 418.215 60.4609 417.767 60.4609H415.681V70H413.337V58.625H417.767C418.658 58.625 419.421 58.7865 420.056 59.1094C420.697 59.4271 421.186 59.8672 421.525 60.4297C421.864 60.9922 422.033 61.6354 422.033 62.3594C422.033 63.0938 421.864 63.7292 421.525 64.2656C421.186 64.8021 420.697 65.2161 420.056 65.5078C419.421 65.7995 418.658 65.9453 417.767 65.9453ZM426.292 58.625V70H423.956V58.625H426.292ZM440.319 68.2422V70H432.538V68.5L436.217 64.5547C436.587 64.1432 436.879 63.7812 437.092 63.4688C437.306 63.151 437.459 62.8672 437.553 62.6172C437.652 62.362 437.702 62.1198 437.702 61.8906C437.702 61.5469 437.644 61.2526 437.53 61.0078C437.415 60.7578 437.246 60.5651 437.022 60.4297C436.803 60.2943 436.532 60.2266 436.209 60.2266C435.866 60.2266 435.569 60.3099 435.319 60.4766C435.074 60.6432 434.886 60.875 434.756 61.1719C434.631 61.4688 434.569 61.8047 434.569 62.1797H432.311C432.311 61.5026 432.472 60.8828 432.795 60.3203C433.118 59.7526 433.574 59.3021 434.163 58.9688C434.751 58.6302 435.449 58.4609 436.256 58.4609C437.053 58.4609 437.725 58.5911 438.272 58.8516C438.824 59.1068 439.241 59.4766 439.522 59.9609C439.808 60.4401 439.952 61.013 439.952 61.6797C439.952 62.0547 439.892 62.4219 439.772 62.7812C439.652 63.1354 439.48 63.4896 439.256 63.8438C439.038 64.1927 438.772 64.5469 438.459 64.9062C438.147 65.2656 437.801 65.638 437.42 66.0234L435.444 68.2422H440.319Z",
    fill: "#4C4C4C"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 1,
    width: 4,
    height: 325,
    fill: "#4C4C4C"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 1,
    width: 4,
    height: 325,
    fill: "#4C4C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourlyLayoutImg3);
export default __webpack_public_path__ + "static/media/hourlyLayoutImg3.62739e9be6af557148e4af2e656101f9.svg";
export { ForwardRef as ReactComponent };